module.exports = {
  year: '年',
  month: '月',
  week: '周',
  day: '天',
  hour: '小时',
  minute: '分钟',
  second: '秒',
  ago: '{0}前',
  in: '{0}后',
  now: '现在'
}



// WEBPACK FOOTER //
// ./~/rctui/lang/zh-cn/timeago.js